export default __webpack_public_path__ + "static/media/djs-landrover.c0b6107a.jpeg";